<mat-expansion-panel class="mat-elevation-z1 progress-drawer mr-24" *ngIf="isVisible" [expanded]="isExpanded" hideToggle="true" (expandedChange)="onExpandedChange($event)">
    <mat-expansion-panel-header>
        <mat-panel-title class="accordion-title" fxLayout="row" fxLayoutAlign="space-between center">
            <h4>
                <mat-progress-spinner diameter="20" class="mr-12" color="accent" mode="indeterminate" *ngIf="inProgressNodeKeys.length"></mat-progress-spinner>
                <span *ngIf="inProgressNodeKeys.length">{{ 'CONTENT.MESSAGE.UPLOADING' | translate }}</span>
                <span *ngIf="!inProgressNodeKeys.length && (failureNodes.length || successNodes.length)">{{ 'CONTENT.LABEL.UPLOADS' | translate }}</span>
            </h4>
            <div fxLayout="row" fxLayoutAlign="flex-end center">
                <mat-icon class="pointer mr-8" *ngIf="isExpanded">keyboard_arrow_down</mat-icon>
                <mat-icon class="pointer mr-8" *ngIf="!isExpanded">keyboard_arrow_up</mat-icon>
                <mat-icon *ngIf="successNodes.length || failureNodes.length" (click)="$event.stopPropagation(); removeFiles()">close</mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="matExpansionPanelContent"></ng-container>
</mat-expansion-panel>

<ng-template #matExpansionPanelContent>
    <mat-list class="mat-elevation-z0" role="list">
        <mat-list-item *ngFor="let fileName of inProgressNodeKeys; let last = last" class="in-progress" role="listitem">
            <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
                <mat-icon class="icon-18 mr-8 blue-icon" [svgIcon]="'status_in_progress'"></mat-icon>
                <div fxLayout="column" class="text-truncate">
                    <div class="text-truncate w-100-p text-sm text-gray-700 font-medium" [title]="fileName">{{ fileName }}</div>
                    <span class="text-xs text-gray-500">{{ 'CONTENT.MESSAGE.UPLOADING' | translate }}... {{ contentNodeService.inProgressNodes[parentNode.id][fileName] }}%</span>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item *ngFor="let node of failureNodes.slice().reverse()" class="failed" role="listitem">
            <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
                <mat-icon class="icon-18 mr-8 red-icon" [svgIcon]="'status_canceled'">add_circle_outline</mat-icon>
                <div fxLayout="column" class="text-truncate">
                    <div class="text-truncate w-100-p text-sm text-gray-700 font-medium" [title]="node.file">{{ node.file }}</div>
                    <span class="text-xs text-gray-500">{{ 'CONTENT.MESSAGE.UPLOAD_FAILED' | translate }}</span>
                </div>
            </div>
        </mat-list-item>
        <mat-list-item *ngFor="let node of successNodes.slice().reverse()" class="completed" role="listitem">
            <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
                <mat-icon class="icon-18 mr-8 green-icon" [svgIcon]="'status_succeeded'"></mat-icon>
                <div fxLayout="column" class="text-truncate">
                    <div class="text-truncate w-100-p text-sm text-gray-700 font-medium" [title]="node.name">{{ node.name }}</div>
                    <span class="text-xs text-gray-500">{{ 'CONTENT.MESSAGE.UPLOAD_COMPLETED' | translate }}</span>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>
